"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMutation = void 0;

var _client = require("@apollo/client");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useMutation = (mutation, options) => {
  var [mutate, {
    loading,
    client
  }] = (0, _client.useMutation)(mutation, _objectSpread({
    notifyOnNetworkStatusChange: true
  }, options));

  var execute = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(function* (variables) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var result = yield mutate(_objectSpread({
        variables
      }, options));
      return result.data;
    });

    return function execute(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return {
    mutate: execute,
    loading,
    client
  };
};

exports.useMutation = useMutation;